import { Button, Col, Form, Input, message, Row } from 'antd';
import { VerifyOtpField } from 'features/auth/components/login-form/types';
import { useCreateResendOtp } from 'features/auth/use-cases/resend-otp';
import { useOtpVerfiy } from 'features/auth/use-cases/verfiyOtp';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

import { StyledBackground, StyledCard, StyledRow } from './login.styles';
// ../use-cases/resend-otp

const OtpView = () => {
  const [otp, setOtp] = useState(Array(6).fill('')); // Initialize OTP with 6 empty fields
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { mutate } = useOtpVerfiy();
  const location = useLocation();
  const { mutate: ResendOtp, isLoading } = useCreateResendOtp();
  const queryParams = new URLSearchParams(location.search);
  const returnUrl: any = queryParams.get('rtt');
  // let id: any, clientid: any, uniqueid: any;
  // if (returnUrl) {
  //   returnUrl?.split('/');
  // }
  const [id, clientid, uniqueid] = (returnUrl && returnUrl.split('/')) || [
    '',
    '',
    '',
  ];

  //   if (returnUrl) {
  //   // Split the returnUrl by '/' and destructure the result
  //   const parts = returnUrl.split('/');
  //   console.log(id,"id");
  //   console.log(clientid,"ccl");

  //   // Ensure there are enough parts to avoid undefined values
  //   if (parts.length >= 4) {
  //     id = parts[1]; // Second part
  //     clientid = parts[2]; // Third part
  //     uniqueid = parts[3]; // Fourth part
  //   } else {
  //     console.error('Return URL does not have enough segments:', returnUrl);
  //   }
  // } else {
  //   console.error('Return URL is not defined');
  // }

  const handleChange = (value: string, index: number) => {
    if (value.length > 1) return; // Ensure only one character is entered
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Automatically move to the next input box if a digit is entered
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    // Handle backspace and move to the previous input box
    if (e.key === 'Backspace') {
      if (otp[index] === '' && index > 0) {
        const prevInput = document.getElementById(`otp-${index - 1}`);
        prevInput?.focus();
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedText = e.clipboardData.getData('Text').replace(/\D/g, '');

    if (pastedText.length === 6) {
      setOtp(pastedText.split(''));
      // message.success(index);
    }
    e.preventDefault();
  };

  // Get UserId from localStorage
  const UserId: any = localStorage.getItem('userId');

  const handleFinish = () => {
    const otpCode = otp.join('');
    setIsSubmitting(true);

    mutate(
      { UserId, VerificationCode: otpCode, persistSession: true },
      {
        onSuccess: (data: any) => {
          setIsSubmitting(false);
          if (returnUrl && id && clientid && uniqueid) {
            navigate(`/universaldocuments/${id}/${clientid}/${uniqueid}`, {
              replace: true,
            });
            message.success('OTP verified successfully!');
          } else if (returnUrl && id && clientid) {
            navigate(`/uploaddocuments/${id}/${clientid}`, { replace: true });
            message.success('OTP verified successfully!');
          } else if (data.rs === 1) {
            navigate(`${ROUTES.HOME}`, { replace: true });
            message.success('OTP verified successfully!');
          } else {
            message.error(
              data.rm || 'Invalid verification code. Please try again.',
            );
          }
        },
        onError: (error) => {
          setIsSubmitting(false); // Set loading false after error
          message.error('Failed to verify OTP. Please try again.');
          console.error('OTP verification error:', error);
        },
      },
    );
  };
  const handleResendOtp = () => {
    const userEmail: any = localStorage.getItem('userEmail');
    const resndOtpValue = {
      Email: userEmail,
      UserType: 2,
    };
    ResendOtp(resndOtpValue);
  };
  const handleSubmit = () => {
    form.setFieldsValue({
      VerificationCode: otp.join(''), // Combine the OTP digits into one VerificationCode
    });
    form.submit(); // Submit the form after setting the value
  };

  return (
    <>
      <StyledBackground className='otpbx'>
        <Col
          xs={24}
          sm={18}
          md={12}
          lg={12}
          xl={10}
          xxl={7}
          className='flex flex-col justify-center p-5'
        >
          <Col xs={24} className='flex justify-center mb-10'>
            <img src='/partnerplus_logo.png' alt='login background' />
          </Col>

          <StyledCard className='p-0'>
            <StyledRow justify='center'>
              <Col
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <label className='mt-0 mb-3 text-center text-2xl font-bold text-blue-950'>
                  Verify OTP
                </label>
              </Col>
            </StyledRow>

            <StyledRow justify='center'>
              <Col xs={24}>
                <Form layout='vertical' form={form} onFinish={handleFinish}>
                  <Form.Item name={VerifyOtpField.VerificationCode} noStyle>
                    <Row gutter={16} justify='center'>
                      {Array.from({ length: 6 }).map((_, index) => (
                        <Col key={index}>
                          <Input
                            id={`otp-${index}`} // Unique ID for each input
                            value={otp[index]}
                            onChange={(e) =>
                              handleChange(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)} // Handle backspace navigation
                            onPaste={(e) => handlePaste(e)}
                            maxLength={1} // Single character per input
                            style={{ width: '45px', textAlign: 'center' }}
                            size='large'
                            autoComplete='off'
                            type='tel' // Ensure it's treated as numeric
                            inputMode='numeric' // Help mobile devices to show numeric keyboard
                          />
                        </Col>
                      ))}
                    </Row>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type='primary'
                      block
                      loading={isSubmitting}
                      disabled={otp.some((digit) => !digit)} // Disable button if any field is empty
                      onClick={handleSubmit} // Trigger setting the value and submitting
                      style={{ marginTop: '20px', textAlign: 'center' }}
                      size='large'
                    >
                      Submit OTP
                    </Button>
                  </Form.Item>
                </Form>
                <div className='mt-5 flex justify-center'>
                  <a href={ROUTES.LOGIN}>Back to Login</a>
                </div>
                <div className='mt-5 flex justify-center'>
                  <Button
                    type='primary'
                    onClick={handleResendOtp}
                    loading={isLoading}
                  >
                    Resend OTP
                  </Button>
                </div>
              </Col>
            </StyledRow>
          </StyledCard>
        </Col>
      </StyledBackground>
    </>
  );
};

export default OtpView;
